import Validation from '@core/logic/Validation'
import NeedsBase from '@master/model/kyc-form/need-analysis/NeedsBase'

export default class IdentifyingYourPriorities extends Validation {
  readonly sections = ['Identifying Your Priorities']

  validate (needs: NeedsBase[], belongsTo: string) {
    this.belongsTo = belongsTo
    const { getMessages, ADD, WHEN, REQUIRE } = this.validator()

    ADD(() => {
      const atLeastOnePlan = needs.some(need => need.plan)
      if (!atLeastOnePlan) {
        return 'For completion, at least 1 \'To Plan For\' priority type must be selected.'
      }
    }, this.sections)

    needs.filter(need => need.plan).forEach(need => {
      ADD(WHEN(!need.level, REQUIRE(need.level, `Priority level for the ${need.name} plan is required`)), this.sections)
    })

    return getMessages()
  }
}
